export const POSITIONS_GROUPS = [
  {
    label: 'Product',
    value: 'product',
  },
  {
    label: 'Account',
    value: 'account_name',
  },

  {
    label: 'Expiry',
    value: 'expires_at',
  },
] as const;

export type PositionGroup = typeof POSITIONS_GROUPS[number];
